import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import ProductCard from '../ProductCard';
import api from '../../services/api';
import './RelatedProducts.css';

const RelatedProducts = ({ category, currentProductId }) => {
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRelatedProducts = async () => {
      try {
        setLoading(true);
        const response = await api.get('/products/');
        const data = response.data;
        const allProducts = Array.isArray(data?.results)
          ? data.results
          : (Array.isArray(data) ? data : []);

        const filteredProducts = allProducts
          .filter(p => p.category === category && p.id !== currentProductId && p.status === 'active')
          .slice(0, 8); // Limit to 8 related products
        setRelatedProducts(filteredProducts);
      } catch (error) {
        console.error('Failed to fetch related products:', error);
      } finally {
        setLoading(false);
      }
    };

    if (category) {
      fetchRelatedProducts();
    }
  }, [category, currentProductId]);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  if (loading || relatedProducts.length === 0) {
    return null; // Don't render if loading or no related products
  }

  return (
    <div className="related-products-container">
      <h3 className="related-products-title">Related Products</h3>
      <Slider {...settings}>
        {relatedProducts.map(product => (
          <div key={product.id} className="related-product-slide">
            <div className="related-product-card">
              <ProductCard product={product} />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default RelatedProducts;
